import { useMutation, useQueryClient } from 'react-query';
import { clearUserEvents } from 'services/userEvent.service';
import { getUserEventsQueryKey } from './useUserEvents';

export const useUserEventActions = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: clear, isLoading: isClearing } = useMutation(clearUserEvents, {
    onSuccess: () => queryClient.invalidateQueries(getUserEventsQueryKey),
  });

  return {
    clear,
    isClearing,
  };
};
